import { api } from '@/api'
import type { WorkspaceRole } from '@/data/roles'

import type { UserGroup, UserGroupPayload, UpdateGroupWorkspaceConfigPayload, UserGroupsListResponse } from './types'

export const getUserGroupsList = (params?: { archived?: boolean }) => {
  const query = new URLSearchParams()
  if (params?.archived) query.append('archived', 'true')
  return api.get(`user-groups?${query.toString()}`).json<UserGroupsListResponse>()
}

export const getUserGroupsWithMembers = ({
  workspaceId,
  workspaceRoles,
}: {
  workspaceId: number
  workspaceRoles?: WorkspaceRole[]
}) => {
  const searchParams = new URLSearchParams()
  if (workspaceRoles?.length) workspaceRoles.forEach((role) => searchParams.append('workspaceRoles', role))

  return api
    .get('user-groups/members', {
      headers: { 'X-Klaus-Workspace': workspaceId.toString() },
      searchParams: searchParams.size > 0 ? searchParams : undefined,
    })
    .json<{ groups: UserGroup[] }>()
}

export const getUserGroup = (id: string) => api.get(`user-groups/${id}`).json<UserGroup>()

export const createUserGroup = (group: UserGroupPayload) => api.post('user-groups', { json: group })

export const updateUserGroup = (id: string, group: UserGroupPayload) =>
  api.put(`user-groups/${id}`, { json: group }).json<UserGroup>()

export const updateGroupWorkspaceConfig = (id: string, group: UpdateGroupWorkspaceConfigPayload) =>
  api.put(`user-groups/${id}/workspace-config`, { json: group }).json<UserGroup>()

export const deleteGroup = (id: string) => api.delete(`user-groups/${id}`)

export const getUserGroupsCount = (params?: { archived?: boolean }) =>
  api
    .get('user-groups-count', { searchParams: params?.archived ? { archived: params.archived } : undefined })
    .json<{ count: number }>()

export const updateGroupVisibility = (id: string, params: { archived?: boolean; hidden?: boolean }) =>
  api.put(`user-groups/${id}/visibility`, { json: params })
